import { isClientSide } from "helpers/globalHelpers";

function useLocalStorage() {
    let Window

    if (typeof window !== 'undefined' && window.localStorage && typeof window.localStorage.getItem !== 'undefined') {
        Window = window
    } else {
        Window = {
            localStorage: {
                getItem: (k: string) => null,
                setItem: (k: string, val: any) => null,
                removeItem: (key: string) => null,
            },
        };
    }
  const setItem = (key: string, value: any) =>
    Window.localStorage.setItem(key, JSON.stringify(value));

  const getItem = <T>(key: string): T => {
    const val = Window.localStorage.getItem(key);
    return val ? JSON.parse(val) : null;
  };
  const removeItem = (key: string) => {
      Window.localStorage.removeItem(key);
  };
  return { setItem, getItem , removeItem };
}

export default useLocalStorage;
